/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateFormTableFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/form-table/create-update/form-edit-create-update-form-table-field-dialog.component';
/* eslint-enable */

/**
 * Decimal field implementation.
 */
export class FormEditFormTableFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateFormTableFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateFormTableFieldDialogComponent)
      .create(this.injector);
  }

}
